export default {"src":"/_next/static/media/Symbol_White.bdc265f2.svg","height":37,"width":82,"blurWidth":0,"blurHeight":0};